import React, {Component} from 'react';
import logo from '../../images/logo_black.svg'
import './Login.scss'
import md5 from 'js-md5';
import {SALT_STRING} from "../../constants/index";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {LoginReq} from "../../api/types";
import {Dispatch} from "redux";
import {ActionType} from "../../reducers/types";
import {injectIntl, IntlShape} from 'react-intl';
import {connect} from "react-redux";
import {NavLink} from "react-router-dom";
import {RouteComponentProps} from "react-router";

interface IProps extends RouteComponentProps<any>{
    dispatch: Dispatch<ActionType<LoginReq>>,
    intl: IntlShape
}

interface IState {
    email: '',
    password: ''
}

class Login extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            email: '',
            password: ''
        }
    }

    _checkLogin = (): boolean => {
        let {intl} = this.props
        if (!this.state.email) {
            toast(intl.formatMessage({id: 'userNameNotNull'}));
            return false
        }
        if (!this.state.password) {
            toast(intl.formatMessage({id: 'passwrodNotNull'}));
            return false
        }
        return true
    }
    handleLogin = (): void => {
        if (this._checkLogin()) {
            let password = md5(this.state.password + SALT_STRING)
            let params = {
                clientId: 'h5',
                email: this.state.email,
                password,
                history: this.props.history
            }
            this.props.dispatch({type: 'LOGIN', payload: params})
        }
    }
    handleEmailChange = (e: any): void => {
        this.setState({email: e.target.value})
    }
    handlePasswordChange = (e: any): void => {
        this.setState({password: e.target.value})
    }

    public render() {
        return (
            <div className="LoginPage">
                <div className="topBar">
                    <img src={logo} alt="logo" className="logo"/>
                </div>
                <div className="LoginForm">
                    <h2>{this.props.intl.formatMessage({id: 'login'})} SCANFORPAY</h2>
                    <div className="formLine">
                        <label>{this.props.intl.formatMessage({id: 'email'})}</label>
                        <input placeholder={this.props.intl.formatMessage({id: 'email'})} value={this.state.email}
                               onChange={this.handleEmailChange}/>
                    </div>
                    <div className="formLine">
                        <label>{this.props.intl.formatMessage({id: 'password'})}</label>
                        <NavLink to="/security/forgot"
                                 className="floatRight">{this.props.intl.formatMessage({id: 'forgetPassword'})}</NavLink>
                        <input placeholder={this.props.intl.formatMessage({id: 'password'})} type="password"
                               value={this.state.password}
                               onChange={this.handlePasswordChange}/>
                    </div>
                    <div className="buttons">
                        <button className="loginButton" onClick={this.handleLogin}>
                            {this.props.intl.formatMessage({id: 'login'})}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(connect()(Login));

